import { z } from 'zod'

export const ZPaginationSearchParams = z.object({
  page: z.number().optional(),
  size: z.number(),
})

export type PaginationSearchParams = Partial<
  z.infer<typeof ZPaginationSearchParams>
>

export const ZInfiniteScrollSearchParams = z.object({
  page: z.number().optional(),
  size: z.number(),
})

export type InfiniteScrollSearchParams = z.infer<
  typeof ZInfiniteScrollSearchParams
>

export type InfiniteScroll<T> = {
  content: T[]
  first: boolean
  last: boolean
}

export type Pagination<T> = {
  content: T[]
  currentPage: number
  size: number
  totalElements: number
  lastPage: number
}
